import React, {Component} from 'react';
import {
    Grid,
    Tooltip,
    TextField,
} from 'material-ui';
import SortableTree from 'react-sortable-tree';
import ContentNodeRendererCustom from './theme/NodeRendererCustom';
import TreeNodeRendererCustom from './theme/TreeRendererCustom';
import {BackButton} from '../../components/buttons/BackButton';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';

class MenuViewTree extends Component {

    render() {
        const {
            menuItemsTreeData,
            menuType,
            menuSite,
            classes,
            updateMenuItemsTreeData
        } = this.props;

        return (
            <Grid container>
                <div className="heading">
                    <p className="lead">View <em>{menuType}</em> menu for <em>{menuSite}</em></p>
                </div>
                <Grid container direction="row" justify="flex-start">
                    <Grid item xs={12} lg={6} className={classes.menuViewTree}>
                        <div style={{height: 700, width: 1280, display: 'inline-block' }}>
                            {<SortableTree
                                treeData={menuItemsTreeData}
                                isVirtualized={false}
                                canDrag={false}
                                onChange={treeData => {updateMenuItemsTreeData(treeData)}}
                                theme={{
                                    nodeContentRenderer: ContentNodeRendererCustom,
                                    treeNodeRenderer: TreeNodeRendererCustom,
                                }}
                                generateNodeProps={({node, path }) => {

                                    if (node.deleted) {
                                        return null;
                                    }

                                    return ({
                                        title: (
                                                <Tooltip title="Menu Item Title">
                                                    <TextField
                                                        className={classes.inputMenuTitle}
                                                        value={node.name}
                                                        disabled={true}
                                                    />
                                                </Tooltip>
                                        ),
                                        buttons: [
                                                <Tooltip title="Menu Item Type">
                                                    <TextField
                                                        name={node.title}
                                                        disabled={true}
                                                        className={classes.selectMenuType}
                                                        value={node.type || ''}
                                                    />
                                                </Tooltip>,
                                            node.type === "link" ?
                                                    <Tooltip title="External link here">
                                                        <TextField
                                                        placeholder="Add external link here"
                                                        className={classes.inputLink}
                                                        disabled={true}
                                                        value={node.href || ''}
                                                    />
                                                </Tooltip>
                                                : '',
                                                <Tooltip title="Menu Item CSS Class">
                                                    <TextField
                                                        className={classes.selectMenuClass}
                                                        name={node.name}
                                                        disabled={true}
                                                        value={node.css_class || ''}
                                                    />
                                                </Tooltip>,
                                            node.deleted === true ?
                                                    <div className={classes.deletedMenuItem}><em>This item and its children have been deleted from the menu!<br/>After saving, the changes will be visible in the menu.</em></div>
                                            : '',
                                        ],
                                    });
                                }

                                }
                            />}
                        </div>
                    </Grid>
                    <Grid item xs={12} className={classes.menusButtons}>
                        <BackButton
                            link={"/menus"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                    <ScrollToTop />
                </Grid>
            </Grid>
        );
    }
}

export default MenuViewTree;


// WEBPACK FOOTER //
// ./src/containers/menus/MenuViewTree.jsx